import { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from "../../../Components/Header/Header";
import Docmnt from '../../../assets/images/google-docs.png';
import { LeftSettings } from '../LeftSettings';
import Shipupload from "../../../assets/images/ship_upload.png";
import { withRFSToken } from '../../../Services/axios.js';
import Select from 'react-select';
import Trash from "../../../assets/images/delete.svg";
import Edit from "../../../assets/images/edit.png";
import Download from "../../../assets/images/chart_download.png";
import { toast } from 'react-toastify';
import { saveAs } from "file-saver";
import Pdfs from "../../../assets/images/pdf.png";

const FileManagementSettings = () => {
    const isMounted = useRef(false);
    const [uploadModal, setShowModalUpload] = useState(false);
    const [files, setFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const fileInputRef = useRef(null);
    const [visibilityId, setVisibilityId] = useState();
    const [visibilityList, setVisibilityList] = useState([]);
    const gridRefs = useRef({});
    const [allData, setAlldata] = useState(null);
    const [deleteId, setDeleteId] = useState();
    const [confModal, setConfModal] = useState(false);


    const hideUploadModal = () => {
        setShowModalUpload(false);
    }

    useEffect(() => {
        if (isMounted.current) return;
        fetchVisibility();
        loadGrid();
        isMounted.current = true;
    }, []);

    const fetchVisibility = async () => {
        try {
            const res = await withRFSToken.post("file-management/visibility-list")
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.label,
                        value: item.value
                    })) : []
                    setVisibilityList(transformData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleUploadSave = async () => {
        let payLoad = {
            "visibility_id": visibilityId,
            "files": base64Files
        }
        try {
            const res = await withRFSToken.post("file-management/save-file-data", payLoad)
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        setShowModalUpload(false);
                        setFiles([]);
                        setBase64Files([]);
                        setVisibilityId('');
                        loadGrid();
                        toast.success(res.data.response_msg);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });
                if (filesWithBase64.length === selectedFiles.length) {
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleChange = (value) => {
        setVisibilityId(value);
    };

    const loadGrid = () => {
        const token = 'Bearer ' + localStorage.ASR;
        const source = {
            datatype: 'json',
            url: `${process.env.REACT_APP_RFS_URL}file-management/list`,
            root: 'Rows',
            cache: false,
            datafields: [
                { name: 'id', type: 'string' },
                { name: 'created_at', type: 'string' },
                { name: 'uploaded_by', type: 'string' },
                { name: 'org_name', type: 'string' },
                { name: 'file_path', type: 'string' },
                { name: 'file_name', type: 'string' },
                { name: 'file_type', type: 'string' },
                { name: 'file_size', type: 'string' },
            ],
            beforeSend: (jqXHR) => {
                jqXHR.setRequestHeader('Authorization', token);
            },
            filter: function (allfilters) {
                window.$(gridRefs.current).jqxGrid('clearselection');
                window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
            },
            beforeprocessing: function (data) {
                setAlldata(data.Rows);
            }
        };
        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
            {
                text: 'Action', datafield: '', width: '8%', filterable: false, filtertype: '',
                cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                    return `<div class="grid_actions"><img class="file_download row_edit" src="${Download}"/><img class="row_delete" src="${Trash}"/></div>`;
                }
            },
            {
                text: 'Preview',
                datafield: 'file_path',
                width: '10%',
                filterable: false,
                cellsrenderer: (row, column, value, rowData) => {
                    if (!value) return '';
                    const ext = value.split('.').pop().toLowerCase();
                    let previewIcon = '';
                    let isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
                    if (isImage) {
                        previewIcon = value;
                    } else if (ext === 'pdf') {
                        previewIcon = Pdfs;
                    } else if (ext === 'doc' || ext === 'docx') {
                        previewIcon = Docmnt;
                    } else {
                        previewIcon = Docmnt;
                    }
                    return `<div class="grid_actions" style="text-align: center;">
                            <img src="${previewIcon}" alt="preview" style="max-height: 26px; max-width: 100%;" />
                        </div>`;
                }
            },
            { text: 'File Name', datafield: 'file_name', width: '10%', filtertype: 'input', },
            { text: 'File Type', datafield: 'file_type', width: '8%', filtertype: 'input', },
            { text: 'File Size', datafield: 'file_size', width: '8%', filtertype: 'input', filterable:false },
            {
                text: 'Uploaded On',
                datafield: 'created_at',
                width: '12%',
                filtertype: 'range',
                cellsrenderer: (row, column, value) => {
                    if (!value) return '';
                    const date = new Date(value);
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    return `<div class="grid_actions">${day}-${month}-${year} ${hours}:${minutes}</div>`;
                }
            },
            { text: 'Uploaded By', datafield: 'uploaded_by', width: '10%', filtertype: 'input', },
            { text: 'Organisation', datafield: 'org_name', width: '10%', filtertype: 'input', },
        ];
        const gridOptions = {
            width: '100%',
            source: dataAdapter,
            columns: columns,
            autoheight: false,
            height: 800,
            sortable: true,
            altrows: false,
            enabletooltips: true,
            editable: false,
            pageable: true,
            pageSize: 50,
            pagerButtonsCount: 5,
            pagerMode: 'advanced',
            filterable: true,
            filterrowheight: 45,
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: function (params) {
                return params.data;
            },
        };
        window.$(gridRefs.current).jqxGrid(gridOptions);
        window.$(gridRefs.current).off('click', '.file_download').on('click', '.file_download', function () {
            const rowDiv = window.$(this).closest('[role="row"]');
            const rowIndex = window.$(rowDiv).attr('row-id');
            const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
            handleDownload(rowData.file_path, rowData.file_name);
        });
        window.$(gridRefs.current).off('click', '.row_delete').on('click', '.row_delete', function () {
            const rowDiv = window.$(this).closest('[role="row"]');
            const rowIndex = window.$(rowDiv).attr('row-id');
            const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
            setDeleteId(rowData.id);
            setConfModal(true);
        });
    };

    const handleDeleteConfirm = async () => {
        try {
            const res = await withRFSToken.get(`file-management/delete?file_id=${deleteId}`)
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        toast.success(res.data.response_msg);
                        loadGrid();
                        setConfModal(false);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    };

    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };

    const SBack = localStorage.getItem('SettingsBack');

    return (
        <>
            {/* <div className="">
                <Header logo_url={SBack ? SBack : '/ServiceRecovery'} sBackUrl={SBack ? SBack : '/ServiceRecovery'} />
                <div className="main-panel">

                    <div className="row">
                        <LeftSettings /> */}
                        <div className='col-9 col-xxl-9 stting_right'>
                            <div className='settingbg_right'>
                                <h4>File Management</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur</p>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <Button variant="primary createplan" onClick={() => setShowModalUpload(true)}>
                                            <FontAwesomeIcon icon={faPlus} /> Upload
                                        </Button>
                                    </div>
                                </div>
                                <div ref={gridRefs} className='bookinggrid userstting'></div>
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div> */}
            <Modal show={uploadModal} centered onHide={hideUploadModal} className='addfrom change_type' >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Add File
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col sm="12" className='mb-3'>
                        <Form.Label>Initial Visibility <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Select
                            options={visibilityList}
                            value={visibilityList.find(option => option.value == visibilityId) || null}
                            onChange={selected => handleChange(selected ? selected.value : '')}
                            placeholder="Select department"
                        />
                    </Col>
                    <Col sm="12">
                        <div className='type_work'>
                            <div className='ra_condition'>
                                <div className='dropfile' onDrop={handleDrop} onDragOver={handleDragOver}>
                                    <img src={Shipupload} alt="upload" />
                                    <h3>Drag and drop files here</h3>
                                    <p>Or</p>
                                    <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                    <span>Maximum file size 4 MB</span>
                                    <input type="file" 
                                    ref={fileInputRef} style={{ display: 'none' }} 
                                    onChange={handleFileChange} multiple 
                                    accept=".doc,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword"
                                    />
                                </div>
                                <div className='uploadbox'>
                                    {files.map((file, index) => (
                                        <div key={index} className='uploadfil'>
                                            {file.base64.includes('image') ? (
                                                <img
                                                    src={file.base64}
                                                    alt="Preview"
                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                />
                                            ) : (
                                                <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                            )}
                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={hideUploadModal}>
                            Discard
                        </Button>
                        <Button variant="primary" onClick={handleUploadSave}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={confModal} onHide={() => setConfModal(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Delete File</h3>
                    <p>Are you sure you want to delete this file? This action cannot be undone.</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setConfModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={handleDeleteConfirm}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default FileManagementSettings;
